import apiInstance from '../index';

import { APIRoutes } from '../../routes';
import { Config } from '../../utils/config';

export interface OrpUserProfile {
    id: string;
    email: string;
    slackUserId: string | null;
    name: string | null;
    username: string | null;
    displayName: string | null;
    firstName: string | null;
    lastName: string | null;
    title: string | null;
    phone: string | null;
    timezone: string | null;
    status: string | null;
    pronouns: string | null;
    avatarUrl: string | null;
    isAdmin: boolean;
    isBot: boolean;
    isActive: boolean;
    dateCreated: string;
    dateModified: string;
}

export async function postOrpUserProfile(email: string): Promise<OrpUserProfile> {
    return (
        await apiInstance.post<OrpUserProfile>(
            APIRoutes.SLACK_USER_DETAILS,
            { email },
            {
                baseURL: `${Config.BaseApiUrl}/originations-review-portal`,
            },
        )
    ).data;
}

export async function getOrpUserProfiles(): Promise<OrpUserProfile[]> {
    return (
        await apiInstance.get<OrpUserProfile[]>(APIRoutes.SLACK_USER_DETAILS, {
            baseURL: `${Config.BaseApiUrl}/originations-review-portal`,
        })
    ).data;
}
